import LoadingSpinner from "app/components/LoadingSpinner/LoadingSpinner";
import { ListRenderValues } from "app/utils/const";
import React from "react";
import { FormattedMessage } from "react-intl";
export default function RenderEndOfList(
  props: Record<string, any>
): React.ReactElement<React.ComponentProps<"div">, "div"> {
  return (
    <div className="asian-competitions-screen__list__end-of-list">
      {props.fullListLoaded ||
      props.competitionList.length < ListRenderValues.THRESHOLD ? (
        <FormattedMessage tagName="span" id="events-nomore" />
      ) : (
        <LoadingSpinner />
      )}
    </div>
  );
}
